<template>
  <div>
    <single-panel-page
      v-show="organization.id"
      class="organization-page"
      :loading="fetchInProgress"
    >
      <template slot="top">
        <div class="logo">
          <img
            alt="Logo"
            :src="organization.logo_url | cld({ w: 200, c: 'limit' })"
            width="200"
          />
        </div>
      </template>

      <br />

      <template v-if="atOrganizationPage">
        <p
          v-if="
            !(
              organization.active_programs &&
              organization.active_programs.length
            )
          "
        >
          Currently there is no active program.
        </p>
        <div
          v-else-if="
            organization &&
            organization.active_programs &&
            organization.active_programs.length > 0
          "
        >
          <ActiveProgramItem
            class="mb-8"
            v-for="program in organization.active_programs"
            :organization="organization"
            :program="program"
            :key="program.id"
          />
        </div>
      </template>
      <template v-else>
        <router-link
          :to="{ name: 'organizationPage' }"
          class="absolute top-[30px] left-[30px] hover:no-underline"
        >
          <ArrowNarrowLeftIcon />
        </router-link>
      </template>

      <router-view />

      <div slot="bottom">
        <span class="splash-box-footer">
          <p>Powered by</p>
          <a href="https://www.vestbee.com">
            <p>www.vestbee.com</p>
          </a>
        </span>
      </div>
    </single-panel-page>

    <Error404 v-show="!(fetchInProgress || organization.id)" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import organizations from 'services/organizations'
import Error404 from 'modules/errors/Error404.vue'
import ActiveProgramItem from './ActiveProgramItem.vue'
import { ArrowNarrowLeftIcon } from '@vue-hero-icons/outline'

export default {
  components: { ActiveProgramItem, Error404, ArrowNarrowLeftIcon },
  props: {
    orgId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      organization: (state) => state.organizationDetails.organization,
      fetchInProgress: (state) => state.organizationDetails.fetchInProgress,
    }),
    atOrganizationPage() {
      return this.$route.name == 'organizationPage'
    },
    applyText() {
      const program = this.organization.active_program
      if (program && program.apply_text) {
        return program.apply_text
      } else {
        const name = this.organization.active_program
          ? this.organization.active_program.name
          : this.organization.name
        return `Apply to ${name}`
      }
    },
  },
  async created() {
    this.$store.dispatch('user/fetchNoRedirect')
    const realOrgId = await this.getRealOrgId()
    try {
      await this.$store.dispatch('organizationDetails/fetch', { id: realOrgId })
    } catch (error) {
      if (error.response.status === 404) {
        // Seems we don't need to handle it in any particular way - just show
        // this.$router.push({path: '/404/no-such-organization'})
      }
    }
  },
  methods: {
    async getRealOrgId() {
      const loweredOrgId = this.orgId.toLowerCase()
      if (loweredOrgId !== this.orgId) {
        // redirect user to lowered case id
        const route = { ...this.$route, path: this.$route.path.toLowerCase() }
        this.$router.replace(this.$route.fullPath.toLowerCase())
        // NOTE: Another option is to refresh whole page with following:
        // window.location.replace(this.$route.fullPath.toLowerCase())
      }
      if (await organizations.shouldRedirect(this.orgId)) {
        const params = { ...this.$route.params }
        const org = await organizations.getRedirectTarget(this.orgId)
        params.orgId = org.name
        this.$router.replace({ ...this.$route, params })
        return org.id
      }
      return (await organizations.nameToId(this.orgId)) || this.orgId
    },
    getProgramApplyRoute(programId) {
      return {
        name: 'organizationPageRegisterStartup',
        params: { orgId: this.orgId, programId: programId },
      }
    },
  },
}
</script>
